<template>
  <div :class="$style.nav">
    <base-swiper
      ref="swiper"
      :data="data"
      :slides-per-view="5"
      :loop="false"
      :slide-change="handleSlideChange"
    >
      <template v-slot:default="slotProps">
        <the-honor-tab
          :text="slotProps.el"
          :class="selected === slotProps.index && 'selected'"
          @click="onTab(slotProps.index)"
        />
      </template>
    </base-swiper>
    <button
      :disabled="selected === data.length - 1"
      :class="$style.next"
      @click="onNext"
    />
    <button :disabled="selected === 0" :class="$style.prev" @click="onPrev" />
  </div>
</template>

<script>
import BaseSwiper from '../BaseSwiper'
import TheHonorTab from './TheHonorTab'

export default {
  components: { BaseSwiper, TheHonorTab },
  props: {
    data: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      selected: 0,
      tabIndex: 0, // switch active index
      watcher: null,
    }
  },
  computed: {
    // 当前可见范围最小 tab index
    min() {
      return this.tabIndex
    },
    // 当前可见范围最大 tab index
    max() {
      return this.tabIndex + 4
    },
  },
  mounted() {
    this.watcher = this.$watch('selected', (val) => {
      if (val < this.min) {
        this.$refs.swiper.slidePrev()
      } else if (val > this.max) {
        this.$refs.swiper.slideNext()
      }
      this.$emit('change', val)
    })
  },
  destroyed() {
    this.watcher && this.watcher()
  },
  methods: {
    handleSlideChange(swiper) {
      this.tabIndex = swiper.activeIndex
    },
    onNext() {
      this.selected += 1
    },
    onPrev() {
      this.selected -= 1
    },
    onTab(index) {
      this.selected = index
    },
  },
}
</script>

<style lang="less" module>
@nav-width: 10.16rem;
@nav-bar-height: 0.42rem;
@nav-swiper-width: 8.6rem;
@nav-arrow-width: 0.32rem;
@nav-arrow-height: 0.27rem;
@nav-arrow-margin: 0.32rem;

.nav-size(@r: 1) {
  .nav {
    width: @nav-width * @r;

    &::before {
      height: @nav-bar-height * @r;
      border-radius: @nav-bar-height * @r;
    }

    :global {
      .swiper-container {
        width: @nav-swiper-width * @r;
      }
    }
  }

  .prev,
  .next {
    .size(@nav-arrow-width * @r, @nav-arrow-height * @r);
  }

  .prev {
    left: @nav-arrow-margin * @r;
  }

  .next {
    right: @nav-arrow-margin * @r;
  }
}

.nav-size();

@media screen and (max-width: @tablet-width) {
  .nav-size(1.2);
}

@media screen and (max-width: @mini-width) {
  .nav-size(1.75);
}

.nav {
  position: relative;
  margin: 0 auto;
  user-select: none;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    background-color: #fbfbfb;
    transform: translateY(-50%);
  }

  :global {
    .swiper-container {
      margin: 0 auto;
    }
  }
}

.prev,
.next {
  position: absolute;
  top: 50%;
  background: url('./images/honor-arrow.png') no-repeat;
  background-size: 200% 100%;
  transform: translateY(-50%);

  &[disabled] {
    opacity: 0.5;
  }
}

.prev {
  background-position: 0 0;
}

.next {
  background-position: 100% 0;
}
</style>
